import { get } from 'lodash';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useDependency } from '../../hooks/useDependency.hook';
import { useForm } from '../../hooks/useForm.hook';
import { useResourceInput } from '../../hooks/useResourceInput';
import overviewService from '../../services/api/overview.service';
import themesService from '../../services/api/themes.service';
import { INPUT_STATES } from '../forms/forms.utils';
import SelectField from '../forms/SelectField';
import TextField from '../forms/TextField';

const DossierOverviewFields = ({ dossierId, data, write, onUpdated }) => {
  const { isSubmitting, reset, input, submitStart, submitOk, submitError } = useForm({
    data
  });
  const [labelsIntermediateValue, setLabelsIntermediateValue] = useState(
    data.theme?.map((t) => t.name)?.filter((t) => !!t) ?? []
  );
  const resource = {
    isFetching: false,
    isSubmitting,
    getValue: (field) => data?.[field],
    setValue: (value, field, options = {}) => {
      submitStart();
      overviewService.update(
        dossierId,
        { [field]: value },
        {
          onSuccess: () => {
            submitOk();
            input(value, field);
            onUpdated(value, field);
            options?.onSuccess();
          },
          onError: (message) => {
            submitError({ [field]: message });
            options?.onError(message);
          }
        }
      );
    },
    onCancel: reset
  };
  const labels = useDependency(themesService.getAll, {
    mapResponse: (resp) => resp?._embedded?.themes?.map((t) => ({ value: t.name, label: t.name })) ?? []
  });

  useEffect(() => {
    labels.onLoad();
  }, [labels]);

  const handleLabelChange = (value) => {
    setLabelsIntermediateValue(value);
  };

  const handleLabelChanged = () => {
    if (
      isSubmitting ||
      data.theme
        ?.map((t) => t.name)
        ?.filter((t) => !!t)
        ?.sort()
        ?.join('') === labelsIntermediateValue?.sort()?.join('')
    ) {
      return;
    }

    submitStart();
    overviewService.update(
      dossierId,
      { theme: labelsIntermediateValue?.map((l) => ({ id: l, name: l })) },
      {
        onSuccess: () => {
          submitOk();
          input(
            labelsIntermediateValue?.map((l) => ({ id: l, name: l })),
            'theme'
          );
          onUpdated(
            labelsIntermediateValue?.map((l) => ({ id: l, name: l })),
            'theme',
            'overview'
          );
        },
        onError: (message) => {
          submitError({ theme: message });
        }
      }
    );
  };

  return (
    <div>
      <div className="row">
        <div className="col-xs-12 u-margin-bottom">
          <SelectField
            label="Label"
            options={labels.options}
            value={labelsIntermediateValue}
            onChange={handleLabelChange}
            onClose={handleLabelChanged}
            multiple
            isSubmitting={isSubmitting}
            disabled={isSubmitting}
            readOnly={!write}
            state={INPUT_STATES.DEFAULT}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 u-margin-bottom-xs">
          <TextField
            label="Algemene informatie"
            value={get(data, 'description')}
            description={'Hier kan je algemene opmerkingen en een korte inhoud over het traject kwijt.'}
            {...useResourceInput('description', resource, '')}
            readOnly={!write}
          />
        </div>
      </div>
      <div className="row u-margin-top-xs u-margin-bottom-xs">
        {/* {get(data, 'school.0.name') && (
          <div className="col-xs-12 col-md-6 col-lg-3 u-margin-bottom-xs">
            <TextField label="School" value={schoolToString(data?.school)} readOnly />
          </div>
        )}
        {get(data, 'branch.0.name') && (
          <div className="col-xs-12 col-md-6 col-lg-3 u-margin-bottom-xs">
            <TextField label="Vestiging" value={branchToString(data?.branch)} readOnly />
          </div>
        )}
        {get(data, 'school.0.type') && (
          <div className="col-xs-12 col-md-6 col-lg-3 u-margin-bottom-xs">
            <TextField label="Niveau" value={get(data, 'school.0.type', '')} readOnly />
          </div>
        )}
        {get(data, 'phoneNumber', '') && (
          <div className="col-xs-12 col-md-6 col-lg-3 u-margin-bottom-xs">
            <TextField label="Algemeen telefoonnr." value={get(data, 'phoneNumber', '')} readOnly />
          </div>
        )}
        {get(data, 'school.cityDistrict', '') && (
          <div className="col-xs-12 col-md-6 col-lg-3 u-margin-bottom-xs">
            <TextField label="Wijk" value={get(data, 'school.cityDistrict', '')} readOnly />
          </div>
        )}
        {get(data, 'school.0.cityDistrictManager', '') && (
          <div className="col-xs-12 col-md-6 col-lg-3 u-margin-bottom-xs">
            <TextField label="Wijkverantwoordelijke" value={get(data, 'school.0.cityDistrictManager', '')} readOnly />
          </div>
        )} */}
        {data?.procedureStartDate && (
          <div className="col-xs-12 col-md-6 col-lg-3 u-margin-bottom-xs">
            <TextField
              label="Startdatum opvolging"
              value={moment(data?.procedureStartDate).format('DD/MM/YYYY') ?? ''}
              readOnly
            />
          </div>
        )}
        {data?.procedureEndDate && (
          <div className="col-xs-12 col-md-6 col-lg-3 u-margin-bottom-xs">
            <TextField
              label="Einddatum opvolging"
              value={moment(data?.procedureEndDate).format('DD/MM/YYYY') ?? ''}
              readOnly
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default DossierOverviewFields;
